import type { CancelablePromise } from "../client"
import { OpenAPI } from "../client"
import { request as __request } from "../client/core/request"

export type InitSalesOrderDraftDTO = {
  warehouse_id: string
  contragent_id?: string
  contractor?: string
  description?: string
}

export type SalesOrderDraftInitResponseDTO = {
  id: string
  number: string
  status: string
  created_at: string
}

export const SalesOrderDraftsService = {
  initSalesOrderDraft: (
    payload: InitSalesOrderDraftDTO,
  ): CancelablePromise<SalesOrderDraftInitResponseDTO> =>
    __request(OpenAPI, {
      method: "POST",
      url: "/v1/sales-orders/drafts",
      body: payload,
      mediaType: "application/json",
    }),
  deleteSalesOrderDraft: (id: string): CancelablePromise<void> =>
    __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/sales-orders/{id}",
      path: { id },
    }),
}
